import { t } from '@if/core/i18n'
import * as yup from '@if/core/yup'

const validateDates = (val: string, ctx: yup.TestContext<yup.AnyObject>): boolean | yup.ValidationError => {
  const fromDate = (ctx.parent as { fromDate: string }).fromDate
  const toDate = val

  if (!val || !fromDate || !toDate || fromDate < toDate) {
    return true
  }

  return ctx.createError({ message: t('merchantStatistics.merchantLoanActivity.dateError') })
}

export const createMerchantLoanActivityMetricsFilterSchema = () => {
  return yup.object({
    merchantId: yup.string().required().default(''),
    fromDate: yup.string().required().default(''),
    toDate: yup
      .string()
      .required()
      .default('')
      .test('validate-dates', (val, ctx) => validateDates(val, ctx)),
  })
}

export type MerchantLoanActivityMetricsFilterFormValues = yup.InferType<
  ReturnType<typeof createMerchantLoanActivityMetricsFilterSchema>
>
